// extracted by mini-css-extract-plugin
export default {"transactionLink":"YoGRyInPC1Ks81urvNS7SA=="};